angular.module('wbDashboard', [
    'ui.router',
    'ui.router.state.events',
    'ngAnimate',
    'ngMessages',
    'ui.bootstrap',
    'angularMoment',
    'daterangepicker',
    'ngTagsInput',
    'angular-clipboard',
    'ui.mask',
    'ui.event',
    'ui.validate',
    'zumba.angular-waypoints',
    'angulartics',
    'angulartics.google.tagmanager',
    'angulartics.mixpanel',
    'angular-bind-html-compile',
    'ngTable',
    'ngFileUpload',
    'ui.bootstrap-slider',
    'slickCarousel',
    'ngIdle',
    'hl.sticky',
    'angular-jwt',
    //custom
    'wbUtilities',

]);
